import { findAncestor } from '../../utils/dom';
import { throttle } from 'throttle-debounce';


export const clickToOpenMegaNav = (): void => {

  const isTouchDevice = () : boolean => {
    return 'ontouchstart' in window        // works on most browsers 
    || 'onmsgesturechange' in window;  // works on IE10 with some false positives
  };

  const navToggles = document.querySelectorAll('[data-nav-toggle]');
  if (navToggles.length <= 0) return;

  const classToToggle = 'menu-open';

  const hoverUnderlays = document.querySelectorAll('[data-nav-hover-underlay]');

  const closeAllMeganavs = () =>
    document.querySelectorAll('[data-nav-item]').forEach(t => t.classList.remove(classToToggle));

  navToggles.forEach(navToggle => {
    navToggle.addEventListener('click', (e) => {
      if (window.innerWidth > 767) {
        if (isTouchDevice()) {
          //don't follow links on touch devices
          e.preventDefault()
          return false;
        }
        //just do the click
        return true
      }
      const parent = findAncestor((<HTMLElement>e.target), 'navItem');
      if (parent) {
        e.preventDefault()
        if (!parent.classList.contains(classToToggle)) {
          // Closing all mega navs
          closeAllMeganavs()
        }

        // Toggle this mega nav
        parent.classList.toggle(classToToggle);  
      }
      return false;
    });
  });

  hoverUnderlays.forEach(hoverUnderlay => {
    const navItem = findAncestor((<HTMLElement>hoverUnderlay), 'navItem');
    hoverUnderlay.addEventListener('mouseenter', () => navItem.classList.add('hover-underlay-closing'))
    navItem.addEventListener('mouseenter', () => navItem.classList.remove('hover-underlay-closing'))
  })

  document.querySelectorAll('[data-nav-btn-back]').forEach(btn =>
    btn.addEventListener('click', () => {
      // Closing all mega navs
      closeAllMeganavs();
    })
  );

  const tabIndexSwap = () => {
    const tabIndexMob = document.querySelectorAll('[data-tabindex-swap="mobile"]');
    const tabIndexDes = document.querySelectorAll('[data-tabindex-swap="desktop"]');

    if (window.innerWidth < 768) {
      tabIndexMob.forEach(el => {
        el.setAttribute('tabIndex', '0');
      });
      tabIndexDes.forEach(el => {
        el.setAttribute('tabIndex', '-1');
      });
    } else {
      tabIndexMob.forEach(el => {
        el.setAttribute('tabIndex', '-1');
      });
      tabIndexDes.forEach(el => {
        el.setAttribute('tabIndex', '0');
      });
    }
  }

  tabIndexSwap();

  window.addEventListener('resize', throttle(500, false, () => {
    tabIndexSwap();
  }));
}